import { Injectable } from '@angular/core';
import {DataService} from "./data.service";
import {Store} from "@ngrx/store";
import {AppState} from "../store";
import {getActiveClassId} from "../store/selectors/teacher.selector";
import {BehaviorSubject} from "rxjs";
import {MetaTagsService} from "./meta-tags.service";

/**
 * This Service takes care of the game session.
 * In controls the STATE of the game session. It can start, end, pause and resume a game session.
 *
 * It does not take care about anything related to time (ticks) or categories.
 */

@Injectable({
  providedIn: 'root'
})
export class GameSessionService {

  schoolClassId: number = 0;
  private gameTimerId = -1;

  gameSessionActive$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  gameSessionPaused$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private data: DataService,
    private store: Store<AppState>,
  ) {
    this.store.select(getActiveClassId()).subscribe((schoolClassId) => {
      this.schoolClassId = schoolClassId;

      if(this.schoolClassId > 0) {
        this.data.getGameTimer(this.schoolClassId).subscribe(response => {
          if(response) {
            this.gameTimerId = response.id;
            this.gameSessionActive$.next(true);
          } else {
            this.gameSessionActive$.next(false);
          }

          // TODO: check if game session is paused
          this.gameSessionPaused$.next(false);

        });
      } else {
        this.gameSessionActive$.next(false);
      }

    });
  }

  startGameSession(duration: number) {
    this.data.startGameTimer(this.schoolClassId, duration).subscribe(response => {
      if(!response) {
        return;
      }
      this.gameTimerId = response.id;
      this.gameSessionActive$.next(true);
    });
  }

  endGameSession() {
    this.data.modifyGameTimer(this.gameTimerId, 0, 'END').subscribe(response => {
      if(response) {
        this.gameTimerId = -1;
        this.gameSessionActive$.next(false);
        this.gameSessionPaused$.next(false);
      }
    });
  }

  pauseGameSession() {
    this.data.modifyGameTimer(this.gameTimerId, 0, 'PAUSE').subscribe(response => {
      this.gameSessionPaused$.next(true);
    });
  }

  resumeGameSession() {
    this.data.modifyGameTimer(this.gameTimerId, 0, 'RESUME').subscribe(response => {
      this.gameSessionPaused$.next(false);
    });
  }

  extendGameSession() {
    this.data.modifyGameTimer(this.gameTimerId, 300, 'EXTEND').subscribe(response => {
      this.gameSessionPaused$.next(false);
    });
  }

}
